import React from "react";

const Courier = () => {
  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col">
          <div className="flex flex-col md:flex-row gap-y-3 items-start">
            <div className="flex items-center text-4xl font-bold head gap-3 md:w-[30%]">
              <span className="text-pry">COURIER</span>
              <div className="h-2 w-4 bg-black"></div>
            </div>
            <div className="md:w-[60%]">
              It is our pleasure to introduce our courier service to you. Cross
              country courier is a division of cross country limited – a one
              stop solution provider and a leading brand in land transportation
              in Nigeria. <br />
              <br /> Leveraging on our extensive branch network strategically
              spread across the six geopolitical zone in the country with
              regional operations in Accra (Ghana), Lome (Togo) and Cotonu
              (Benin), our team of professional, courteous and dedicated staff
              are always at hand to ensure proper handling and prompt delivery
              of all consignments (mail, cargo, etc) anywhere in Nigeria and the
              West African Coast. <br />
              <br /> We have gone the extra mile to add value to our
              courier-service delivery to ensure our growing customers are truly
              satisfied. <br />
              <br /> We are perfectly placed to deliver your goods anywhere in
              Nigeria. <br />
              <br />
              <ul className="list-disc px-4">
                <li>Next-Day Deliveries</li>
                <li>Efficient Service</li>
                <li>Door-to-Door Delivery</li>
                <li>Moderate Rates</li>
                <li>Moderate Rates Security of Consignments</li>
                <li>Insurance</li>
              </ul>
              <br />
              Thank you for giving us the opportunity to serve you. We deliver
              with uncommon diligence.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Courier;
